{
  "nl": {
    "tools_meta": {
      "ai_chat_prefix": "AI-Chat",
      "ai_converters_prefix": "AI voor Mediacreatie",
      "ai_document_qas_prefix": "PDF-Chat",
      "ai_feedbacks_prefix": "Beoordelingsassistent",
      "ai_images_prefix": "Afbeeldingsgenerator",
      "ai_mini_tools_prefix": "Promptlab",
      "ai_assistants_prefix": "AI-Assistenten",
      "ai_personas_prefix": "Personagechat",
      "audio_recorder_prefix": "Audio-Opname",
      "file_sharing_prefix": "Bestanden Delen",
      "link_shortener_prefix": "Linkverkorter",
      "pinboard_prefix": "Prikbord",
      "pupil_feedback_prefix": "AI-Feedback",
      "qrcodes_prefix": "QR-Codegenerator",
      "school_class_prefix": "Klassenruimtes",
      "screen_recorder_prefix": "Schermopname",
      "surveys_prefix": "Enquête",
      "teaching_board_prefix": "Digitale Tafels",
      "text_editor_prefix": "Tekstbewerker",
      "title": "AI-Tools, cursussen en lesmateriaal voor leerkrachten",
      "video_recorder_prefix": "Video-Opname",
      "website_prefix": "Websites",
      "word_clouds_prefix": "Woordwolk",
      "worksheet_prefix": "Werkblad"
    }
  }
}
